import { PendingInvoice } from "./types";

export type PendingInvoiceType =
  | "plan"
  | "addon-seats"
  | "addon-credits"
  | "recharge-manual"
  | "recharge-auto"
  | "unknown";

export const getPendingInvoiceType = (
  invoice: PendingInvoice
): PendingInvoiceType => {
  const desc = invoice.description.toLowerCase();

  if (invoice.type === "plan" || desc.includes("plan")) return "plan";

  if (invoice.type === "addon" || desc.includes("addon")) {
    if (desc.includes("user") || desc.includes("seat")) return "addon-seats";
    if (desc.includes("credit")) return "addon-credits";
    return "addon-seats";
  }

  if (invoice.type === "recharge") {
    if (desc.includes("manual")) return "recharge-manual";
    if (desc.includes("auto")) return "recharge-auto";
    return "recharge-manual";
  }

  // Fallback: infer from description when type is null
  if (desc.includes("user") || desc.includes("seat")) return "addon-seats";
  if (desc.includes("credit")) return "addon-credits";
  if (desc.includes("recharge")) return "recharge-auto";

  return "unknown";
};
